import React from 'react'

import ScrollToComponent from 'scroll-to'

import { ContentScrollTo } from './styles'

interface IScrollTo {
  to: string
  children: React.ReactNode
  styles?: string
  title: string
}

const ScrollTo: React.FC<IScrollTo> = ({
  to,
  children,
  styles,
  title,
}: IScrollTo): React.ReactElement => {
  function scrollTo(evt: React.MouseEvent<HTMLAnchorElement>) {
    evt.preventDefault()
    const { currentTarget: target } = evt
    const { hash } = target

    if (!hash) {
      return
    }

    const topElement = document.getElementById(hash.replace('#', ''))
    if (!topElement) {
      return
    }
    const offsetTopElem = topElement.getBoundingClientRect()
    if (typeof window !== 'undefined') {
      const top = offsetTopElem.top + window.scrollY - 70
      window.scroll({
        top,
        behavior: 'smooth',
      })
      ScrollToComponent(0, top, {
        ease: 'in-out-quad',
        duration: 1100,
      })
    }
  }

  return (
    <ContentScrollTo>
      <a href={to} onClick={scrollTo} className={styles} title={title}>
        {children}
      </a>
    </ContentScrollTo>
  )
}

export default ScrollTo
